import { createAction, props } from "@ngrx/store";

export const LOAD_DEMANDE_ACHAT_LIST = "[Demande Achat List] Load Demande Achat List";
export const LOAD_DEMANDE_ACHAT_LIST_SUCCESS = "[Demande Achat List] Load Demande Achat List Success";
export const LOAD_DEMANDE_ACHAT_LIST_FAIL = "[Demande Achat List] Load Demande Achat List Fail";

export const LoadDemandeAchatList = createAction(LOAD_DEMANDE_ACHAT_LIST);
export const LoadDemandeAchatListSuccess = createAction(LOAD_DEMANDE_ACHAT_LIST_SUCCESS, props<{ demandeAchatList: any }>());
export const LoadDemandeAchatListFail = createAction(LOAD_DEMANDE_ACHAT_LIST_FAIL, props<{ error: string }>()); /**/
